import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OthesInfoDataForm.html?raw';

class OthesInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    ContactData_NameInput: HTMLElement;

    _onChangeContactDataInput(): void {

        
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OthesInfoDataForm);